/* eslint-disable @next/next/no-img-element */
"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { compareExperiencesByPriority } from "@/utils/experienceSort";

type Attraction = {
  id: string;
  title: string;
  description: string;
  image: string;
  background: string;
  complement: string;
  hasQueue: boolean;
  hasComplement: boolean;
  isActive: boolean;
  localId: string;
};

const SELECTED_ATTRACTION_STORAGE_KEY = "selected-attraction";

export default function ListExperiences() {
  const [exp, setExp] = useState<Attraction[]>([]);

  useEffect(() => {
    let isMounted = true;

    void fetch(
      `api/list-atracoes?state=${localStorage.getItem("state") === "SP" ? 1 : 2}`,
      { cache: "no-store" },
    )
      .then(async (res) => res.json())
      .then((req) => {
        if (!isMounted) return;
        const sortedAttractions = Array.isArray(req)
          ? [...req].sort(compareExperiencesByPriority)
          : [];

        setExp(sortedAttractions);
      })
      .catch(() => {
        if (!isMounted) return;
        setExp([]);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  function handleSelectAttraction(attraction: Attraction) {
    window.sessionStorage.setItem(
      SELECTED_ATTRACTION_STORAGE_KEY,
      JSON.stringify(attraction),
    );
  }

  function renderBackgroundColor(color: string) {
    switch (color) {
      case "#fec822":
        return "#2033ef";
        break;

      case "#fec823":
        return "#2033ef";
        break;

      case "#fec822":
        return "#2033ef";
        break;

      case "#FEC822":
        return "#2033ef";
        break;

      case "#fec823":
        return "#2033ef";
        break;

      case "#FEC823":
        return "#2033ef";
        break;

      default:
        return color;
        break;
    }
  }

  function renderColor(color: string) {
    switch (color) {
      case "#fec822":
        return "#fff";
        break;

      case "#fec823":
        return "#fff";
        break;

      case "#FFE800":
        return "#2033ef";
        break;

      case "#FFE600":
        return "#2033ef";
        break;

      default:
        return "#fff";
        break;
    }
  }

  return (
    <section
      className="games-section reveal-up"
      style={{
        backgroundColor: "white",
        paddingTop: 40,
        paddingBottom: 40,
        minHeight: 620,
      }}
      id="jogos"
    >
      <div className="lg:pt-10 pl-5 pt-10">
        <h1 className="font-extrabold text-[#2033ef] text-[34px] uppercase">
          Experiências
        </h1>
        <div className="scrollbar-hidden mt-2 flex lg:flex-row flex-col flex-wrap items-start justify-start w-full gap-5 overflow-x-auto overflow-y-hidden pr-5 pb-2 mb-6">
          {exp.map((attraction) => (
            <Link
              key={attraction.id}
              href={`/experiencias/${attraction.id}`}
              onClick={() => handleSelectAttraction(attraction)}
              className="w-full min-w-[100%] max-w-[90%] lg:min-w-[310px] lg:max-w-[310px] overflow-hidden rounded-[20px] items-center justify-center flex flex-col"
              style={{
                backgroundColor: renderBackgroundColor(attraction.background),
              }}
            >
              <img
                className="flex h-[70px] w-[90px] min-w-[180px] object-contain pt-2"
                src={attraction.image}
                alt={attraction.title}
              />
              <h1
                className="font-bold text-[11px] pt-2 pb-2 uppercase font-bold"
                style={{
                  color: renderColor(attraction.background),
                }}
              >
                {attraction.title}
              </h1>
            </Link>
          ))}
        </div>
      </div>

      <style jsx>{`
        .games-section {
          min-height: 260px;
          color: white;
          scroll-margin-top: 6.5rem;
        }

        @media (max-width: 640px) {
          .games-section {
          }
        }
      `}</style>
    </section>
  );
}
